import { message as $message } from 'antd'
import { myPartnerStatusNum } from '@/services/myPartner'

const RedTipModel = {
    namespace: 'redTip',
    state: {
        SUPPLIER: false,
        CHANNEL: false,
    },
    effects: {
        *query({ payload }, { call, put }) {
            try {
                const res = yield call(myPartnerStatusNum, {
                    ...payload.params,
                })
                if (res.success) {
                    if (res.data) {
                        yield put({
                            type: 'updateRedTip',
                            payload: {
                                [payload.params.originator]: res.data.auditNum >= 1,
                            },
                        })
                        return res.data
                    }
                } else {
                    $message.error(res.message)
                }
            } catch (e) {
                console.error('catchError', e)
            }
        },
        *changeTip({ payload }, { put }) {
            yield put({
                type: 'updateRedTip',
                payload,
            })
        },
    },
    reducers: {
        updateRedTip(state, { payload }) {
            return {
                ...state,
                ...payload,
            }
        },
    },
}

export default RedTipModel
